import '../../index.css';
var styles = {
  "hiddenWidthSetter": "bp_tabs_module_hiddenWidthSetter--eeded",
  "contentSwitchTabList": "bp_tabs_module_contentSwitchTabList--eeded",
  "contentSwitchTab": "bp_tabs_module_contentSwitchTab--eeded",
  "tabsListContainer": "bp_tabs_module_tabsListContainer--eeded",
  "tabList": "bp_tabs_module_tabList--eeded",
  "tabSeparator": "bp_tabs_module_tabSeparator--eeded",
  "tab": "bp_tabs_module_tab--eeded"
};
export { styles as default };